export default function bindCommentoEl(elId: string, scriptId: string) {
  const foundCommentoScript = document.querySelector(`#${scriptId}`);
  if (foundCommentoScript) {
    foundCommentoScript.remove();
  }
  const foundCommentoEl = document.querySelector(`#${elId}`);
  if (foundCommentoEl) (foundCommentoEl as HTMLElement).innerHTML = '';
  const commentoScript = document.createElement('script');
  commentoScript.setAttribute('id', scriptId);
  commentoScript.setAttribute('defer', '');
  commentoScript.setAttribute('src', 'https://cdn.commento.io/js/commento.js');
  document.head.append(commentoScript);
}
